import React from "react";
import Navbar from "../components/Navbar";
import CounterTile from "../components/CounterTile";

import OverviewChart from "../components/OverviewChart";
import PerformanceChart from "../components/PerformanceChart";
import DevicesTable from "../components/DevicesTable";

const Home = () => {
  document.body.style = "background-color: #FAFCFE";
  return (
    <>
      <header>
        <Navbar userName={"Jack"} />
      </header>
      <main className="main">
        <div className="home__tile">
          <CounterTile className="counter-tile counter-tile--today" icon="card" currency="£" value={1535} about="Total Raised - Today" />
          <CounterTile className="counter-tile counter-tile--month" icon="card" currency="£" value={2950} about="Total Raised - Month" />
          <CounterTile className="counter-tile counter-tile--giftaid" icon="gift" currency="£" value={737} about="Total GiftAid - Month" />
          <CounterTile className="counter-tile counter-tile--year" icon="calendar" currency="£" value={8250} about="Total Raised - Year" />
        </div>
        <div className="home__charts">
          <OverviewChart />
          <PerformanceChart />
        </div>
        <DevicesTable />
      </main>
    </>
  );
};

export default Home;
